import { useEffect, useState } from 'react';
type VntanaResponse = {
	arQRImageBase64: string;
	view360URL: string;
};
export const useVNTANA360AndQRImageUrlDetails = ({
	sku,
	storeConfData,
	isVisualSupportEnabled,
}: {
	sku: string;
	storeConfData: Record<string, string>;
	isVisualSupportEnabled: boolean;
}) => {
	const arEnabled = storeConfData?.ENABLE_AR === 'true';

	const [isLoading, setIsLoading] = useState(false);
	const [arQrImageBase64, setArQrImageBase64] = useState<string>('');
	const [view360URL, setView360URL] = useState<string>('');
	const [isArEnabled, setIsArEnabled] = useState(false);

	useEffect(() => {
		if (!isVisualSupportEnabled || !arEnabled || !sku) return;

		const fetchVNTANAData = async () => {
			setIsLoading(true);
			setIsArEnabled(false);
			setArQrImageBase64('');
			setView360URL('');

			try {
				const response = await fetch(`/api/accenture-vntana?sku=${encodeURIComponent(sku)}`);

				if (!response.ok) {
					return;
				}

				const data: VntanaResponse = await response.json();

				if (data.view360URL) {
					setView360URL(data.view360URL);
				}

				if (data.arQRImageBase64) {
					setArQrImageBase64(data.arQRImageBase64);
				}

				setIsArEnabled(true);
			} catch (error) {
				console.error('useVNTANA360AndQRImageUrlDetails:', error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchVNTANAData();
	}, [arEnabled, sku, isVisualSupportEnabled]);

	return { isLoading, isArEnabled, arQrImageBase64, view360URL };
};
